import React from 'react';
import ConfirmActionModal from '../../components/ConfirmActionModal';
import type { ActionModalProps } from '../../constants';
import useTrackEvent from '~/hooks/useTrackEvent';

export type Props = {
  dataTestId?: string;
} & ActionModalProps;

const Subscribe: React.FCC<Props> = ({
  onCancel,
  onComplete,
  selectedContactAmount,
  ...rest
}) => {
  const trackEvent = useTrackEvent();
  return (
    <ConfirmActionModal
      selectedContactAmount={selectedContactAmount}
      actionType="Subscribe"
      actionInput={{
        Subscribe: {},
      }}
      onComplete={() => {
        /** ----- TRACKING: contacts_subscribed ----- */
        trackEvent({
          eventName: 'contacts_subscribed',
          parameters: {
            contacts_amount: selectedContactAmount,
          },
        });
        onComplete();
      }}
      onCancel={onCancel}
      {...rest}
    />
  );
};

export default Subscribe;
